/** Placeholder for screens that later slices will build. */
export default function ComingSoon({ title, slice }: { title: string; slice?: number }) {
  return (
    <main className="page">
      <h1>{title}</h1>
      <p className="subtitle">
        {slice ? `This screen is coming in Slice ${slice}.` : 'There is no page at this address.'}
      </p>
    </main>
  )
}
